<a [routerLink]="'/u/' + _user.userId" *ngIf="_user">
  <user-avatar [user]="_user" size="h-5 w-5" class="mr-1"></user-avatar>
  <span>{{_user.username}}</span>
</a>
